import { computed, makeObservable } from 'mobx';

import { createModelSchema, primitive } from 'serializr';
import { optional } from '@vromo/models';

type ResultsType = { [key: string]: boolean | null }

export class SimulatedOfferRule {
    rule: number | null = null;
    pickupToDropoffBy: boolean | null = null;
    rangeBy: number | null = null;
    afterCreationBy: number | null = null;
    beforeDeadlineBy: number | null = null;
    maxJobsBy: number | null = null;

    inTeam: boolean | null = null;

    offered: boolean | null = null;
    containsControlledContents: boolean | null = null;
    isOrderValueLessThan: boolean | null = null;
    isOrderValueGreaterThan: boolean | null = null;
    hasCorrectPaymentMethod: boolean | null = null;

    constructor() {
        makeObservable(this, {
            results: computed
        });
    }

    get results(): ResultsType {
        return {
            team: this.inTeam,
            range: 0 <= this.rangeBy!,
            afterCreation: 0 <= this.afterCreationBy!,
            beforeDeadline: 0 <= this.beforeDeadlineBy!,
            maxJobs: 0 <= this.maxJobsBy!,
            pickupToDropoffGreaterThan: this.pickupToDropoffBy,
            pickupToDropoffLessThan: this.pickupToDropoffBy,
            checkControlledContents: this.containsControlledContents,
            orderValueLessThan: this.isOrderValueLessThan,
            orderValueGreaterThan: this.isOrderValueGreaterThan,
            paymentMethod: this.hasCorrectPaymentMethod
        };
    }
}

createModelSchema(SimulatedOfferRule, {
    afterCreationBy: optional(primitive()),
    beforeDeadlineBy: optional(primitive()),
    inTeam: optional(primitive()),
    maxJobsBy: optional(primitive()),
    offered: optional(primitive()),
    pickupToDropoffBy: optional(primitive()),
    rangeBy: optional(primitive()),
    rule: optional(primitive()),
    containsControlledContents: optional(primitive()),
    isOrderValueLessThan: optional(primitive()),
    isOrderValueGreaterThan: optional(primitive()),
    hasCorrectPaymentMethod: optional(primitive()),
});
